export const SocketEvents = {
    LOCATION_SET: 'location/set',
    ROUTE: {
        NEW_ROUTE: 'route/new',
        ROUTE_ACCEPTED: 'route/accepted',
        DRIVER_ON_LOCATION: 'route/on-location',
        TRAVEL_INITED: 'route/inited',
        TRAVEL_CANCELLED: 'route/cancelled',
        DRIVER_ARRIVED: 'route/driver-arrived',
        TRAVEL_FINISH: 'route/finish',
        FLOW: {
            PENDING: 'route/flow/pending',
			REJECTED: 'route/flow/rejected',
			ACCEPTED: 'route/flow/accepted',
			ALERT_UNACCEPTED: 'route/flow/alert-unaccepted',
			CONFIRMED: 'route/flow/confirmed',
			ALERT_UNCONFIRMED: 'route/flow/alert-unconfirmed',
			INITIATED: 'route/flow/initiated',
			ALERT_UNINITIATED: 'route/flow/alert-uninitiated',
			FINISHED: 'route/flow/finished',
        }
    },
    USER: {
        DISABLE_USER: 'user/disable',
        UPDATED_USER: 'user/updated',
        SET_SERVICE: 'user/set-service',
        CHECK_DISABLED: 'user/check-disabled',
    },
    MAINTENANCE: {
        ALERT: 'maintenance/alert',
    }
}